// extracted by mini-css-extract-plugin
module.exports = {"shadowCardWrapper":"ShadowCard_shadowCardWrapper__OeZls"};